/* 正则列表 */
export default {
  number: /^[0-9]*$/,
  float: /^[+-]?((\d*(\.\d{1,})$)|(\d+$))/,
  // 1-99（包含）的整数
  'number1-99': /^([1-9][0-9]{0,1})$/,
  // 项目统一金额校验规则，小数点后最多输入两位
  money: /^\d+(\.\d{0,2})?$/,
  //处罚金额，小数点后6位
  money2: /^\d+(\.\d{0,6})?$/,
  // url
  url: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/,
  // QQ号码
  qq: /^\d{5,12}$/,
  // 座机
  phone: /^((0\d{2,3})-?)(\d{7,8})(-?(\d{0,3}))?$/,
  // 手机号码
  mobile: /^1[234567890]\d{9}$/,
  //联系方式：手机或座机
  mobileOrPhone: /^1[234567890]\d{9}$|^((0\d{2,3})-?)(\d{7,8})(-?(\d{0,3}))?$/,
  // 邮箱
  email: /^\s*\w+(?:\.{0,1}[\w-]+)*@[a-zA-Z0-9]+(?:[-.][a-zA-Z0-9]+)*\.[a-zA-Z]+\s*$/,
  // 身份证
  idCard: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
  //密码：大小写字母+数字,6-20位
  password: /^(?=[0-9a-zA-Z]*[a-z])(?=[0-9a-zA-Z]*[A-Z])(?=[0-9a-zA-Z]*\d)[0-9a-zA-Z]{6,20}$/,
  //密码：同时包含字母，数字，特殊符号(包括下划线)，6-18位
  password2: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~_!@#$%^&*])[\da-zA-Z~_!@#$%^&*]{6,18}$/,
  //密码：由数字、26个英文字母或者下划线组成的字符串:
  password3: /^[0-9a-zA-Z_]{1,}$/,
  //IP地址
  IP: /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/,
  //端口号
  port: /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
  //统一社会信用代码(同时支持18位和15位社会信用代码) 18位：/[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/。15位：/^[A-Za-z0-9]\w{14}$/g
  creditCode: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
  //中文
  chinese: /^[\u4e00-\u9fa5],{0,}$/,
  //字母或者数字 6-18位
  enOrNumber: /^[A-Za-z0-9]{6,18}$/,
  //必须同时包含字母和数字 6-18位
  enAndNumber: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
  //组织机构代码
  organizationCode: /[A-Z0-9]{8}-[A-Z0-9]$|[A-Z0-9]{8}-[A-Z0-9]-[0-9]{2}$/,
  //邮政编码
  zipCode: /^[0-9]{6}$/,
  //军官证
  soldier: /^[a-zA-Z0-9]{7,21}$/,
  //护照(两种类型)
  passport1: /^[a-zA-Z0-9]{3,21}$/,
  passport2: /^(P\d{7})|(G\d{8})$/,
  //港澳回归证 和 台胞证
  gangaotaiPass: /^[a-zA-Z0-9]{5,21}$/,
  //歪果仁永久居留身份证号 （外国人居留证号码由3位字母 + 12位数字组成,3位字母表达式国家代号,1到4位数字表示办证机关代码,5到10位数字表示出生年月日）
  alienIdCard: /^[A-Z]{3}\d{6}(?:0[1-9]|1[021])(?:0[1-9]|[21]\d|3[10])\d{2}$/,
  //得分，评分（0-100之间数字，保留两位小数）
  score: /^(\d{1,2}(\.[0-9]{1,2})?)$|^100$/,
  //得分，评分（可为正、负的数字，最多保留两位小数）
  score2: /(^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$)/,
  //中文
  chinese2: /^([\u4E00-\u9FA5])*$/,
  //英文
  english: /^[A-Za-z\s]+$/,
  //税务登记号：15或者17或者18或者20位字母、数字组成
  taxReg: /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/,
  //学号或教师工号 1-18位
  studentOrTeacherNumber: /^[A-Za-z0-9]{1,18}$/,
  //小数点后一位
  float1: /^\d+(\.\d{0,1})?$/,
};


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/regexp.js
// module id = null
// module chunks = 